import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const promotionsRoute: InvariantJiraRoute = {
	name: 'marketplace-promotions',
	path: '/jira/marketplace/manage/promotions',
};
